// Tanggal berakhir promo (WIB). Ubah di sini bila promo diperpanjang.
export const PROMO_END = new Date("2026-08-31T23:59:59+07:00");

export const getRemaining = (end = PROMO_END) => {
  const diff = end.getTime() - Date.now();
  if (diff <= 0) return { ended: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return { ended: false, days, hours, minutes, seconds };
};
